import { Attachment } from '@sdk/attachments/types';
import useGalleryState from '@sdk/components/ui/LightboxGallery/hooks/useGalleryState';
import useImageAttachments from '@sdk/attachments/hooks/useImageAttachments';

type Props = {
  attachments: Attachment[];
};

export function usePreview({ attachments }: Props) {
  const { open, close, isOpen, openUrl } = useGalleryState();
  const images = useImageAttachments(attachments);

  const openAttachment = (attachment: Attachment) => {
    const image = images.find((a) => a.id === attachment.id);

    if (image) {
      open(image.large);
      return;
    }

    // TODO: Handle video
    // TODO: Handle pdf

    window.open(attachment.url, '_blank');
  };

  return {
    images,
    isGalleryOpen: isOpen,
    closeGallery: close,
    currentImageUrl: openUrl,
    openAttachment,
  };
}
